<template>

  <div v-if="!hasPermission('List Prescription Protocol')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
      <Toolbar />
      <div class="container-xxl">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              <div class="d-flex align-items-center position-relative my-1">
              <span class="svg-icon svg-icon-1 position-absolute ms-6">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                        transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                  <path
                      d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                      fill="black"></path>
                </svg>
              </span>
                <input type="text" data-kt-user-table-filter="search" v-model="search"
                       class="form-control form-control-solid w-250px ps-14"
                       placeholder="Pesquisar ...">
              </div>
            </div>
            <div class="card-toolbar">
              <div class="col-md-6" v-show="professionals.length > 1">
                <select class="form-select form-control-solid" aria-label="Selecionar Profissional"
                        v-model="currentProfessionalId" @change="loadPrescProts($event.target.value)">
                  <option value="" disabled selected v-if="professionals.length > 1">--Selecione--</option>
                  <option :value="professional.id_prof" v-for="professional in professionals">
                    {{ professional.prof_name }}
                  </option>
                </select>
              </div>
              <div class="col-md-6">
                <button class="btn btn-flex btn-primary m-1" data-bs-toggle="modal"
                        title="Novo Protocolo" data-bs-target="#modal_store_presc_prot"
                        v-if="hasPermission('Store Prescription Protocol')"
                        @click="searchPrescProt=''; currentPrescProt='';">
                  <i class="bi bi-plus-lg"></i>Adicionar
                </button>
              </div>
            </div>
          </div> <!-- card header -->
          <div class="card-body py-4">
            <table class="table table-row-bordered gy-5">
              <thead>
              <tr class="fw-bold fs-6 text-muted">
                <th>Modelo</th>
                <th>Tipo de conteúdo</th>
                <th style="text-align: center">Ativo</th>
                <th style="text-align: center">Ações</th>
              </tr>
              </thead>
              <tbody v-for="prescProt in prescProtsFiltered" :key="prescProt.id_presc_prot">
              <tr>
                <td>{{ prescProt.presc_prot_name }}</td>
                <td>{{ contentTypeLabel(prescProt.content_type) }}</td>
                <td style="text-align: center">
                  <span class="badge badge-light-success" v-if="prescProt.active">Sim</span>
                  <span class="badge badge-light-danger" v-else>Não</span>
                </td>
                <td style="text-align: center">
                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                          v-if="hasPermission('Update Prescription Protocol')"
                          @click="onClickBtnEdit(prescProt)"
                          data-bs-toggle="modal"
                          data-bs-target="#modal_store_presc_prot"
                          title="Editar">
                    <i class="bi bi-pencil-square"></i>
                  </button>
                  <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                          title="Ver medicamentos"
                          rel="tooltip"
                          v-if="hasPermission('List Prescription Protocol Drug') && isMedicationModel(prescProt)"
                          @click="getDrugs(prescProt.id_presc_prot);">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                          v-if="hasPermission('Delete Prescription Protocol')"
                          @click="deletePrescProt(prescProt.id_presc_prot)"
                          data-bs-toggle="tooltip" title="Excluir Protocolo">
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>

              <tr v-if="!drugsHide && currentPrescProtId === prescProt.id_presc_prot && !loading && isMedicationModel(prescProt)">
                <td colspan="4">
                  <div class="d-flex justify-content-end">
                    <button class="btn btn-light-primary me-3" data-bs-toggle="modal"
                            v-if="hasPermission('Store Prescription Protocol Drug')"
                            title="Novo Medicamento" data-bs-target="#modal_store_drug" @click="formStoreDrug.active=true;">
                      <i class="bi bi-plus-lg"></i> Novo Medicamento
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="!drugsHide && drugs.length && currentPrescProtId === prescProt.id_presc_prot && !loading && isMedicationModel(prescProt)">
                <td colspan="4">
                  <table class="table table-row-bordered table-hover table-light gy-3">
                    <thead>
                    <tr class="fw-bold fs-6 text-muted">
                      <th style="text-align: center">#</th>
                      <th>Medicamento</th>
                      <th>Posologia</th>
                      <th>Tempo de tratamento</th>
                      <th style="text-align: center">Receituário</th>
                      <th>Observação</th>
                      <th style="text-align: center">Adminsitração</th>
                      <th style="text-align: center">Açoes</th>
                    </tr>
                    </thead>
                    <tr v-for="(drug, index) in drugs" :key="drug.id_presc_prot_drug">
                      <td style="text-align: center">{{ index + 1 }}</td>
                      <td style="white-space:pre-wrap; word-wrap:break-word">{{ drug.drug_name }}</td>
                      <td>{{ drug.dosage_desc }}</td>
                      <td>{{ drug.treatment_time }}</td>
                      <td style="text-align: center"><RegulatoryBadge :classification="badgeFor(drug)"/></td>
                      <td style="white-space:pre-wrap; word-wrap:break-word">{{ drug.drug_obs }}</td>
                      <td style="text-align: center">{{ drug.drug_administration?.drug_admin_name }}</td>
                      <td style="text-align: center">
                        <button type="button" class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                data-bs-toggle="modal"
                                data-bs-target="#modal_edit_drug"
                                v-if="hasPermission('Update Prescription Protocol Drug')"
                                @click="onClickBtnEditDrug(drug)"
                                title="Editar">
                          <i class="bi bi-pencil-square"></i>
                        </button>
                        <button class="btn btn-icon btn-bg-light btn-active-color-primary me-1"
                                v-if="hasPermission('Delete Prescription Protocol Drug')"
                                @click="deleteDrug(drug.id_presc_prot_drug)"
                                data-bs-toggle="tooltip" title="Excluir Medicamento">
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr> <!-- drug table -->
              </tbody>
            </table>
          </div> <!-- card body -->
        </div> <!-- card -->

        <prescriptionProtocolDrugs
            :presc-prot="currentPrescProt"
            :drug-admins="drugAdmins"
            :presc-types="prescTypes"
            :current-professional-id="currentProfessionalId"
            :content-types="contentTypes"
            :grid-presets="gridPresets"
            :structured-list-presets="structuredListPresets"
            @onClose="this.loadPrescProts(this.currentProfessionalId); drugsHide = true;">
        </prescriptionProtocolDrugs>

        <div class="modal fade" tabindex="-1" id="modal_store_drug">
          <div class="modal-dialog modal-lg">
            <form method="post" @submit.prevent="submitFormStoreDrug">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Adicionar medicamento</h5>
                  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                       aria-label="Fechar">
                    <i class="bi bi-x-lg"></i>
                  </div>
                </div>
                <div class="modal-body">
                  <PrescriptionDrugFields :drug="formStoreDrug"
                                          :drug-admins="drugAdmins"
                                          :errors="formStoreDrugErrors"
                                          id-prefix="protocol-drug-store"
                                          @catalog="applyCatalogDrug(formStoreDrug, $event)"
                                          @clear-catalog="clearCatalogLink(formStoreDrug)"/>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                  <button type="submit" class="btn btn-primary">Cadastrar</button>
                </div>
              </div>
            </form>
          </div>
        </div> <!-- modal_store_drug -->

        <div class="modal fade" tabindex="-1" id="modal_edit_drug">
          <div class="modal-dialog modal-lg">
            <form method="post" @submit.prevent="submitFormEditDrug">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title">Editar medicamento</h5>
                  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal"
                       aria-label="Fechar">
                    <i class="bi bi-x-lg"></i>
                  </div>
                </div>
                <div class="modal-body">
                  <PrescriptionDrugFields :drug="formEditDrug"
                                          :drug-admins="drugAdmins"
                                          :errors="formEditDrugErrors"
                                          id-prefix="protocol-drug-edit"
                                          @catalog="applyCatalogDrug(formEditDrug, $event)"
                                          @clear-catalog="clearCatalogLink(formEditDrug)"/>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
                  <button type="submit" class="btn btn-primary">Salvar</button>
                </div>
              </div>
            </form>
          </div>
        </div> <!-- modal_edit_drug -->

      </div>
  </div>

</template>

<script>
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
//import draggable from 'vuedraggable'
import prescriptionProtocolDrugs from "./PrescriptionProtocolDrugs";
import Permission from "../../helpers/permission";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import RegulatoryBadge from "@/views/attendance/shared/RegulatoryBadge.vue";
import PrescriptionDrugFields from "@/views/attendance/shared/PrescriptionDrugFields.vue";
import {loadRegulatoryTypes} from "@/helpers/regulatoryTypes";

export default {
  name: "PrescriptionProtocol",
  components: {
    PrescriptionDrugFields,
    //draggable,
    prescriptionProtocolDrugs,
      Toolbar, RegulatoryBadge},
  data() {
    return {
      search: '',
      drugsHide: true,
      loading: false,
      draging: false,
      updatingDrug: false,
      currentProfessionalId: '',
      currentPrescProtId: '',
      currentPrescProt: '',
      prescProts: [],
      allPrescProts: [],
      drugs: [],
      searchPrescProt: '',
      prescTypes: [],
      drugAdmins: [],
      contentTypes: {},
      gridPresets: {},
      structuredListPresets: {},
      formStoreDrug: {
        id_presc_prot: '',
        id_presc_type: '',
        item_kind: 'medication',
        id_drug_admin: '',
        drug_name: '',
        measure: '',
        composition: '',
        regulatory_type: 'SIMPLES',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        continuous_use: false,
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
      },
      formStoreDrugErrors: [],
      formEditDrug: {
        id_presc_prot: '',
        id_presc_type: '',
        item_kind: 'medication',
        id_drug_admin: '',
        drug_name: '',
        measure: '',
        composition: '',
        regulatory_type: 'SIMPLES',
        id_drug: null,
        concentration: '',
        pharmaceutical_form: '',
        quantity: '',
        continuous_use: false,
        dosage_desc: '',
        treatment_time: '',
        drug_obs: '',
      },
      formEditDrugErrors: [],
    }
  },
  computed: {
    /**
     * O receituario sai da substancia na emissao (7.7.5). Este campo continua
     * indo para a API porque importProtocol agrupa os itens por ele: um valor
     * so para o modelo inteiro deixa a quebra por tipo com o motor regulatorio.
     */
    legacyPrescTypeId() {
      const tipos = this.prescTypes ?? [];

      return (tipos.find((tipo) => !tipo.presc_type_special) ?? tipos[0])?.id_presc_type ?? '';
    },
    place() {
      return this.$store.state.auth.place;
    },
    professionals() {
      return this.$store.state.auth.professionals;
    },
    prescProtsFiltered() {
      return this.prescProts.filter(prescProt => {
        return prescProt.presc_prot_name.toLowerCase().includes(this.search.toLowerCase())
      })
    },
  },
  created() {
    loadRegulatoryTypes().catch(() => {});
    this.loadPrescTypes();
    this.loadAdminDrugs();
  },
  mounted() {
    if (this.professionals.length > 0) {
      this.currentProfessionalId = this.$store.state.auth.user.id_prof ?? this.professionals[0].id_prof;
      this.loadModelCatalogs(this.currentProfessionalId);
      this.loadPrescProts(this.currentProfessionalId);
    }
  },
  methods: {
    hasPermission(permission) {
      return Permission.has(permission);
    },
    loadPrescProts(professionalId) {
      this.prescProts = [];
      this.drugsHide = true;
      this.currentProfessionalId = professionalId;
      this.loadModelCatalogs(professionalId);
      http.get(`/professionals/${professionalId}/prescription-models`).then((response) => {
        this.prescProts = response.data;
      });
    },
    loadModelCatalogs(professionalId) {
      if (!professionalId) {
        return;
      }
      http.get(`/professionals/${professionalId}/prescription-models/content-types`).then((response) => {
        this.contentTypes = response.data;
      });
      http.get(`/professionals/${professionalId}/prescription-models/grid-presets`).then((response) => {
        this.gridPresets = response.data;
      });
      http.get(`/professionals/${professionalId}/prescription-models/structured-list-presets`).then((response) => {
        this.structuredListPresets = response.data;
      });
    },
    badgeFor(drug) {
      if (!drug.regulatory_status) {
        return null;
      }

      return {
        status: drug.regulatory_status,
        regulatory_type: drug.regulatory_type ?? null,
        regulatory_type_description: drug.regulatory_type_description ?? null,
        reason_description: 'Sem classificação: o receituário terá de ser escolhido na hora de prescrever.',
        manual: false,
      };
    },
    applyCatalogDrug(form, drug) {
      form.id_drug = drug.id_drug;
      form.drug_name = drug.drug_name;
      form.concentration = drug.concentration ?? '';
      form.pharmaceutical_form = drug.pharmaceutical_form ?? '';
      form.regulatory_status = drug.regulatory_status ?? null;
      form.regulatory_type = drug.regulatory_type ?? null;
      form.regulatory_type_description = drug.regulatory_type_description ?? null;
    },
    // Concentração e forma continuam: no manipulado elas costumam valer, o que
    // deixa de valer é o vínculo com o item industrializado do catálogo.
    clearCatalogLink(form) {
      form.id_drug = null;
      form.regulatory_status = null;
      if (form.item_kind === 'compounded') {
        return;
      }
      form.regulatory_type = null;
      form.regulatory_type_description = null;
    },
    contentTypeLabel(type) {
      return this.contentTypes[type] ?? type ?? 'Medicamentos';
    },
    isMedicationModel(model) {
      return (model?.content_type ?? 'medication') === 'medication';
    },
    loadPrescTypes() {
      this.prescTypes = [];
      http.get(`/prescription-types`).then((response) => {
        this.prescTypes = response.data;
      });
    },
    loadAdminDrugs() {
      this.drugAdmins = [];
      http.get(`/drug-administrations`).then((response) => {
        this.drugAdmins = response.data;
      });
    },
    async onClickBtnEdit(prescProt) {
      if (this.isMedicationModel(prescProt)) {
        this.loadDrugs(prescProt.id_presc_prot).then((response) => {
          this.currentPrescProt = prescProt;
          this.currentPrescProt.drugs = response.data;
        });
      } else {
        this.currentPrescProt = {...prescProt, drugs: []};
      }
    },
    onClickBtnEditDrug(drug) {
      this.formEditDrug.id_presc_prot_drug = drug.id_presc_prot_drug;
      this.formEditDrug.id_presc_prot = drug.id_presc_prot;
      this.formEditDrug.id_presc_type = drug.id_presc_type;
      this.formEditDrug.item_kind = drug.item_kind ?? 'medication';
      this.formEditDrug.id_drug_admin = drug.id_drug_admin;
      this.formEditDrug.drug_name = drug.drug_name;
      this.formEditDrug.measure = drug.measure ?? '';
      this.formEditDrug.composition = drug.composition ?? '';
      this.formEditDrug.regulatory_type = drug.regulatory_type ?? 'SIMPLES';
      this.formEditDrug.id_drug = drug.id_drug ?? null;
      this.formEditDrug.concentration = drug.concentration ?? '';
      this.formEditDrug.pharmaceutical_form = drug.pharmaceutical_form ?? '';
      this.formEditDrug.quantity = drug.quantity ?? '';
      this.formEditDrug.continuous_use = drug.continuous_use ?? false;
      this.formEditDrug.dosage_desc = drug.dosage_desc;
      this.formEditDrug.treatment_time = drug.treatment_time ?? '';
      this.formEditDrug.drug_obs = drug.drug_obs ?? '';
    },
    submitFormStoreDrug() {
      this.formStoreDrug.id_prof = this.currentProfessionalId;
      this.formStoreDrug.id_presc_prot = this.currentPrescProtId;
      this.formStoreDrug.id_presc_type = this.legacyPrescTypeId;
      this.formStoreDrugErrors = [];
      http.post(`/professionals/${this.currentProfessionalId}/prescription-protocols/${this.currentPrescProtId}/drugs`, this.formStoreDrug).then(_ => {
        this.getDrugs(this.currentPrescProtId, false);
        Alert.toastSuccess("Medicamento cadastrado com sucesso.");
        this.formStoreDrug = {
          id_presc_prot: '',
          id_presc_type: '',
          id_drug_admin: '',
          drug_name: '',
          id_drug: null,
          concentration: '',
          pharmaceutical_form: '',
          quantity: '',
          continuous_use: false,
          dosage_desc: '',
          treatment_time: '',
          drug_obs: '',
        };
        bootstrap.Modal.getInstance(document.getElementById('modal_store_drug')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formStoreDrugErrors = e.response.data.errors;
        }
      });
    },
    submitFormEditDrug() {
      this.formEditDrug.id_presc_type = this.legacyPrescTypeId;
      this.formEditDrugErrors = [];
      http.put(`/professionals/${this.currentProfessionalId}/prescription-protocols/${this.currentPrescProtId}/drugs/${this.formEditDrug.id_presc_prot_drug}`, this.formEditDrug).then(() => {
        this.getDrugs(this.currentPrescProtId, false);
        Alert.toastSuccess("Medicamento atualizado com sucesso.");
        bootstrap.Modal.getInstance(document.getElementById('modal_edit_drug')).toggle();
      }).catch(e => {
        Alert.toastError(e.response.data.message ?? e.response.data);
        if (e.response.data.errors) {
          this.formEditDrugErrors = e.response.data.errors;
        }
      });
    },
    deletePrescProt(prescProtId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o protocolo de medicamento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.currentProfessionalId}/prescription-protocols/${prescProtId}`).then(_ => {
            this.loadPrescProts(this.currentProfessionalId);
            Alert.toastSuccess("Protocolo excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    deleteDrug(drugId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o medicamento?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.currentProfessionalId}/prescription-protocols/${this.currentPrescProtId}/drugs/${drugId}`).then(_ => {
            this.getDrugs(this.currentPrescProtId, false);
            Alert.toastSuccess("Medicamento excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    async getDrugs(prescProtId, switchDrugsHide = true) {
      if (!this.drugsHide && switchDrugsHide && this.currentPrescProtId === prescProtId) {
        this.drugsHide = true;
        return;
      }
      this.loadDrugs(prescProtId).then((response) => {
        this.drugs = response.data;
        this.loading = false;
        this.drugsHide = false;
      });
      this.loading = switchDrugsHide ? true : this.loading;
      this.currentPrescProtId = prescProtId;
    },
    loadDrugs(prescProtId) {
      return http.get(`/professionals/${this.currentProfessionalId}/prescription-protocols/${prescProtId}/drugs`).then((response) => {
        return response;
      }).catch(e => {
        Alert.toastError(e.response.data);
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped>
</style>